import i18n from 'src/utils/translate';

import * as actionTypes from './actionTypes';
import { createAuthenticatedApiInstance } from 'src/utils/api';
import { enforcePostStructure } from 'src/utils/dataStructure/enforce';
import { setAlert } from 'src/typescript/components/alert/actions';
import { error } from 'loglevel';
import Router from 'next/router';

export const pollFetch = (
  id: string | number,
  groupCode: string,
) => async (dispatch: any, getState: any) => {
  dispatch({type: actionTypes.POLL_FETCH});
  try {
    const api = createAuthenticatedApiInstance(getState);
    const response = await api.auroraGet(`poll/${id}`, {params: {id, groupCode}});
    //@ts-ignore
    const { data: { payload: { poll: postData, users = [], ratings, userRatings, isFollowing } = {}, status } } = response;

    if (!status?.success) {
      throw Error(status?.message);
    }

    // TODO: remove this when we use solaris endpoints
    const post = enforcePostStructure(postData, users, [], ratings, userRatings, isFollowing);
    const responses = (post.responses || [])
    .map((response: any) => enforcePostStructure(response, users, [], ratings, userRatings));

    dispatch({
      type: actionTypes.POLL_FETCH_SUCCESS,
      post: {
        ...post,
        ...postData,
        responses,
      },
    });
  } catch (ex) {
    error(ex);
    dispatch({type: actionTypes.POLL_FETCH_FAILURE, error: ex});
    dispatch(setAlert(ex?.message || i18n.t('There was a problem. Please refresh the page and try again.')));
  }
};

export const pollVote = (
  id: string,
  groupCode: string,
  choices: string[],
) => async (dispatch: any, getState: any) => {
  dispatch({type: actionTypes.POLL_VOTE});
  try {
    const api = createAuthenticatedApiInstance(getState);
    const { data: { status } } = await api.auroraPost(`poll/${id}/vote`, {id, groupCode, choices});

    if (!status?.success) {
      throw Error(status?.message);
    }

    dispatch({type: actionTypes.POLL_VOTE_SUCCESS});
    dispatch(pollFetch(id, groupCode));
  } catch (ex) {
    error(ex);
    dispatch({type: actionTypes.POLL_VOTE_FAILURE, error: ex});
    dispatch(setAlert(ex?.message || i18n.t('There was a problem. Please refresh the page and try again.')));
  }
};

export const pollResultsShow = () => async (dispatch: any) => {
  dispatch({type: actionTypes.POLL_RESULTS_SHOW});
};

export const pollResultsHide = () => async (dispatch: any) => {
  dispatch({type: actionTypes.POLL_RESULTS_HIDE});
};

export const pollChangeVote = () => async (dispatch: any) => {
  // TODO: Update Aurora endpoint to allow for user vote to be changed
  dispatch({type: actionTypes.POLL_CHANGE_VOTE});
};

export const deletePoll = (
  postId: number | string,
  communitySlug: string,
  successMessage: string | JSX.Element) => {
  return async (dispatch: any, getState: any) => {
    dispatch({ type: actionTypes.DELETE_POLL });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const response = await api.auroraDel(`poll/${postId}`, {
        params: {
          groupCode: communitySlug,
          id: postId,
        },
      });
      const { data: { status } } = response;

      if (!!status && !status.success) {
        dispatch({ type: actionTypes.DELETE_POLL_FAILURE, error: status });
        dispatch(setAlert(status.message));
        return;
      }

      dispatch({
        type: actionTypes.DELETE_POLL_SUCCESS,
        postId,
      });

      dispatch(setAlert(successMessage, 'success'));
      Router.push(
        `/community/communityHome?slug=${communitySlug}`,
        `/${communitySlug}`,
      );
    } catch (ex) {
      error(ex);
      dispatch({ type: actionTypes.DELETE_POLL_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};
